<div class="container-fuid bg-white default-boxrounded">
    <div class="col-12 w-100">
        <h3 class="title col-9">
            <span translate="Settings.IntegrationsServicesSection.XbrlRenderService"></span>
        </h3>
    </div>
    <div class="p-4 pt-0">
        <label for="RenderclientEnvironment" class="form-label" translate="Settings.IntegrationsServicesSection.SelectXBRLRenderService"></label>
        <div ngbDropdown class="dropdown" ngDefaultControl id="RenderclientEnvironment">
            <button class="btn dropdown-toggle form-control text-truncate default" type="button" id="dropdownMenu" ngbDropdownToggle>
                <span *ngIf="xbrlRenderService !== ''">{{ xbrlRenderService }}</span>
                <em class="bi bi-chevron-down float-end ms-2" aria-hidden="true"></em>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownMenu">
                <button ngbDropdownItem value="" (click)="updateValue('')">&nbsp;</button>
                <button ngbDropdownItem value="Batavia" (click)="updateValue('Batavia')">Batavia</button>
            </div>
        </div>
        <div class="col-12 mt-4 pb-2 d-table w-100">
            <span class="float-start"><button type="button" class="btn btn-sm btn-outline-primary" (click)="closeDialog()" translate>Button.Back</button></span>
            <span class="float-end"><button type="button" class="btn btn-sm btn-primary" (click)="save()" translate>Button.SaveChanges</button></span>
        </div>
    </div>
</div>